import { hyphenate } from '../utils/stringFormatter';
var msPattern = /^ms-/;
export default (function (string) {
  return hyphenate(string).replace(msPattern, '-ms-');
});